<template>
  <!-- 平面图 -->
  <div class="guide-wrapper w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" :model="form" ref="form">
        <el-row>
          <el-col :span="6">
            <el-form-item>
              <el-input v-model="form.name" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm()">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;添加平面图
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="name" label="楼层" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.name | filterFloor(that)}}</span>
            </template>
          </el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="20%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleView(scope.row)">查看</a>
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>

              <!-- <a class="mr-10" @click="upCarousel(scope.row)" v-if="scope.$index != 0"><i class="el-icon-top"></i></a>
                <a @click="downCarousel(scope.row)" v-if="((listQuery.currentPage-1)*listQuery.size + scope.$index +1) != total"><i class="el-icon-bottom"></i></a> -->

            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog :title="operation == 'add' ? '新增平面图': operation == 'edit' ? '编辑平面图':'查看平面图'" @close="onCancel"
        :close-on-click-modal="false" :visible.sync="dialogVisible" :width="'600px'">
        <el-form ref="form" :model="addForm" :rules="rules">
          <el-form-item class="mb-30" prop="name">
            <el-select v-model="addForm.name" :disabled="operation == 'view'" placeholder="请选择楼层">
              <el-option v-for="item in floorList" :key="item.dictCode" :label="item.dictName"
                :value="item.dictCode"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="mb-30" prop="areaOne">
            <el-input v-model="addForm.areaOne" :disabled="operation == 'view'" placeholder="请输入建筑面积（万m²）" />
          </el-form-item>

          <el-form-item class="mb-30" prop="areaTwo">
            <el-input v-model="addForm.areaTwo" :disabled="operation == 'view'" placeholder="请输入展厅面积（万m²）" />
          </el-form-item>

          <el-form-item class="mb-30" prop="areaThree">
            <el-input v-model="addForm.areaThree" :disabled="operation == 'view'" placeholder="请输入文物库房面积（万m²）" />
          </el-form-item>

          <el-form-item class="mb-30" prop="url">
            <el-input v-model="addForm.url" :disabled="operation == 'view'" placeholder="请输入图片URL" />
          </el-form-item>

          <el-form-item class="avatar-uploader-form" prop="picId">
            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="operation == 'view'" accept=".jpg,.jpeg,.png,.JPG" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="imgUrl" style="height:120px;object-fit:contain;" :src="imgUrl" class="avatar">
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传平面图封面</div>
              </div>
            </el-upload>
            <div class="tip-img">建议图片大小：258 * 194</div>

            <!-- <div class="uploader-form" @click="uploadPicture()">
              <img v-if="imgUrl" :src="imgUrl" alt="">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>

              <div class="tip-img">建议图片大小：258 * 194</div>

            </div> -->
          </el-form-item>
        </el-form>
        <div class="dialog-footer tr mt-30" v-if="operation != 'view'">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" :loading="loadingSave" @click="onSubmit()">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 剪裁组件弹窗 -->
    <cropper-image ref="cropperRef" @uploadImgSuccess="handleAvatarSuccess">
    </cropper-image>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import CropperImage from "@cmp/cropper";

export default {
  computed: {
    ...mapGetters(['imageTypes']),
  },
  components: { CropperImage },
  data() {
    const validateFile = (rule, value, callback) => {
      if (!this.addForm.picId) {
        callback(new Error('平面图不能为空'))
      } else {
        callback()
      }
    }
    return {
      that: this,
      form: {
        name: '',
        type: '2'
      },
      loadingSave: false,
      operation: 'add',
      addForm: {},
      rules: {
        name: [{ required: true, message: '平面图名称不能为空', trigger: 'blur' }],
        picId: [{ required: true, validator: validateFile, trigger: 'blur' }],
        areaOne: [{ required: true, message: '建筑面积不能为空', trigger: 'blur' }],
        areaTwo: [{ required: true, message: '展厅面积不能为空', trigger: 'blur' }],
        areaThree: [{ required: true, message: '文物库房面积不能为空', trigger: 'blur' }],


      },
      configData: {
        tableName: 'collect'
      },
      imgUrl: "",
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      floorList: [],
      tableData: [],
      dialogVisible: false
    }
  },
  filters: {
    filterFloor(floor, self) {
      let obj = self.floorList.filter(item => {
        return item.dictCode == floor
      })

      if (obj && obj.length > 0) {
        return obj[0].dictName
      }

      return null
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$api.applet.getCarouselList({
        ...this.form,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },


    // 重置查询
    resetForm() {
      this.form = {
        name: '',
        type: '2'
      }
      this.listQuery.currentPage = 1
      this.getData()
    },

    //封面设置
    uploadPicture() {
      if (this.operation == "view") {
        return
      }
      let option = {
        cropWidth: "258", cropHeight: "194", imgUrl: this.imgUrl
      }
      this.$refs.cropperRef.initCropper(option)
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    handleView(obj) {
      this.operation = "view"
      this.$api.applet.getCarouselDetail({ id: obj.id }).then(res => {
        if (res.success) {
          if (res && res.result) {
            this.dialogVisible = true
            this.addForm = res.result
            if (res.result.picId) {
              this.imgUrl = res.result.picId
            }

          }
        }
      })
    },

    // 新增
    handleAdd(operator, id) {
      this.operation = "add"
      this.dialogVisible = true
    },

    handleEdit(obj) {
      this.operation = "edit"
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))
      if (obj.picId && obj.picId.indexOf('/singleMuseum/attach/getFile') == -1) {
        this.imgUrl = `/singleMuseum/attach/getFile?fileId=${obj.picId}`
      } else {
        if (obj.picId) {
          this.addForm.picId = obj.picId.split('=')[1]
          this.imgUrl = obj.picId
        }
      }
    },

    getSelectData() {
      this.$api.common.getSelectDataByKey({ key: 'floor_type' }).then(res => {
        if (res.success) {
          this.floorList = res.result
        }
      })
    },

    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.applet.delCarousel({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        })
        return
      }

      if (this.imageTypes.includes(fileType)) {
        return true

      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return false
      }
    },


    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        this.addForm.picId = res.result.attId
        if (this.addForm.picId) {
          this.$refs.form.clearValidate('picId');
        }
      } else {
        this.$message.error(res.message)
      }
    },

    onSubmit() {
      const self = this
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.loadingSave = true
          let url = "addCarousel"
          if (this.addForm.id) {
            url = "updateCarousel"
          }

          this.addForm.type = '2'
          this.$api.applet[url](this.addForm).then(res => {
            this.loadingSave = false
            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '平面图修改成功' : '新增平面图成功',
                duration: 500,
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.imgUrl = ""
                  self.getData()
                }
              })
            } else {
              this.$message.error(res.message)
            }
          }).catch(err => {
            this.loadingSave = false
          })
        } else {
          return false;
        }
      });
    },

    onCancel() {
      this.dialogVisible = false
      this.addForm = {}
      this.imgUrl = ""
      this.$refs["form"].clearValidate()
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    },

  },
  created() {
    this.getData()
    this.getSelectData()
    window.addEventListener('keyup', this.keydown)

  }
}
</script>

<style lang="scss" scoped>
.guide-wrapper {
  /deep/ .el-form-item {
    .el-form-item__content {
      margin-left: 0 !important;
    }

    &.avatar-uploader-form {
      display: flex;
      flex-direction: column;
      .tip-img{
        left: 0;
      }
      .uploader-form {
        position: relative;
        width: 258px;
        height: 194px;
        display: flex;
        cursor: pointer;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border: 1px dashed #8c939d;

        img {
          width: 100%;
          height: 100%;
        }
        .tip-img{
          left: 0;
        }

        i {
          font-size: 34px;
        }
      }
      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }

      .avatar-uploader {
        width: 50%;
        border: 1px dashed #8c939d;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .el-upload {
          width: 100%;
        }
        .el-icon-plus {
          font-size: 20px;
        }

        .el-upload__text {
          line-height: 1;
        }
      }
    }
  }
  /deep/ .el-select {
    width: 100%;
  }
}
</style>